import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { SecretUserDetails } from '../types/secret-user-details.type'
import { CoreEnvironmentService } from './core-environment.service'
import { DestroyService } from './destroy.service'

@Injectable({
  providedIn: 'root'
})
export class SecretUserDetailsService {
  private readonly coreEnvironmentService = inject(CoreEnvironmentService)
  private readonly destroy$ = inject(DestroyService)
  private readonly http = inject(HttpClient)

  secretUserDetails$ = new BehaviorSubject<SecretUserDetails>(null)

  private readonly baseUrl = this.coreEnvironmentService.getBaseURL()
  private readonly userDetailsBaseEndpoint = '/auth/auth/SecretGetUserDetails'
  private readonly httpOptions = { withCredentials: true }

  getSecretUserDetails() {
    const url = `${this.baseUrl}${this.userDetailsBaseEndpoint}`
    this.http
      .get<SecretUserDetails>(url, this.httpOptions)
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.secretUserDetails$.next(result)
      })
  }
}
